import { RegistrationModelSerialResponse } from '../../models/registration-model-serial/registration-model-serial-response.interface';

export const mockRegistrationModelSerialResponse: RegistrationModelSerialResponse =
  {
    status: 'OK',
  };
